// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',

    [theme.breakpoints.down(424)]: {
      flexDirection: 'column',
    },
  },
  column: {
    flex: 1,
  },
  row: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',

    '&:first-child': {
      marginTop: 0,
    },

    [theme.breakpoints.down(424)]: {
      marginTop: 4,

      '&:first-child': {
        marginTop: 4,
      },
    },
  },
  staticText: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  text: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonStyle: {
    backgroundColor: GlobalStyles.color.COLOR_SECONDARY,
  },
  validateText: {
    margin: '10px 0 0',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_REJECT,
  }
});

export default styles;
